import $ from 'jquery';
import axios from 'axios';

$('body').on('click', '#show-more-listings', function () {
	const $this = $(this);

	axios.get(wajax.api_url + '/listings-filter/?' + $this.data('query'), {}).then(res => {
		$('#filter-results').append(res.data.data.html.results);
		$('#show-more-listings').replaceWith(res.data.data.html.pagination);
	});

});
